import React from 'react';
import { Flex } from '@chakra-ui/react';

const TABS = ['Pay As You Go', 'Membership'] as const;
export type TabType = typeof TABS[number];

interface TabProps {
  children: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
}

interface TabNavProps {
  selectedTab: TabType;
  onSelectTab: (tab: TabType) => void;
}

const Tab = ({ children, isSelected, onClick }: TabProps) => (
  <Flex
    height="14"
    padding="5"
    fontWeight="bold"
    borderWidth="medium"
    borderTopRadius="10"
    borderBottomWidth="0"
    alignItems="center"
    cursor="pointer"
    borderColor={isSelected ? 'hoverLightBlue' : '#D0D4E1'}
    _hover={{
      borderColor: 'hoverLightBlue',
    }}
    onClick={onClick}
  >
    {children}
  </Flex>
);

const TabNav = ({ selectedTab, onSelectTab }: TabNavProps) => (
  <Flex
    mx="auto"
    maxW="5xl"
    mb="14"
    borderBottomWidth="medium"
    borderBottomColor="hoverLightBlue"
    justifyContent="center"
  >
    {TABS.map(tabText => (
      <Tab
        key={tabText}
        isSelected={selectedTab === tabText}
        onClick={() => onSelectTab(tabText)}
      >
        {tabText}
      </Tab>
    ))}
  </Flex>
);

export default TabNav;
